import Vue from 'vue'

import { get } from '@/api/base'

const reportingApi = {
  getActionFilters: async params => {
    const response = await get({
      path: `reporting/actions/filters`,
      params,
    })
    return response.success ? response.data : response
  },
  getActionStats: async params => {
    const response = await get({
      path: `reporting/actions/stats`,
      params,
    })
    return response.success ? response.data : response
  },
  getForBranch: async params => {
    const response = await get({
      path: `reporting/branch`,
      params,
    })
    return response.success ? response.data : response
  },
  getForRUMS: async companyUuid => {
    const response = await get({
      path: `reporting/rums`,
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data : response
  },
  getOrderStats: async companyUuid => {
    const response = await get({
      path: `orders/emptying_stats`,
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data : response
  },
  getAreaStats: async companyUuid => {
    const response = await get({
      path: `orders/area_stats`,
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data : response
  },
}

export const lazyLoadTables = Vue.observable([])

export default reportingApi
